import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const DrawerMeta: ComponentMeta = {
  componentName: "Drawer",
  package: "@mijadesign/web",
  title: "抽屉",
  description: "屏幕边缘滑出的浮层面板",
  category: ComponentCategory.FEEDBACK,
  icon: "MenuFoldOutlined",
  canHaveChildren: true,
  editorDnd: {
    // 抽屉只在内容区承接投放，避免 header/遮罩区域误投放
    partialDropRegion: true,
    overlayEditMode: "drawer",
  },
  visibleInComponentPanel: true,
  props: [
    {
      name: "title",
      label: "标题",
      type: PropType.STRING,
      defaultValue: "抽屉标题",
      group: "基础",
    },
    {
      name: "open",
      label: "显示",
      type: PropType.BOOLEAN,
      defaultValue: true,
      bindable: true,
      bindSources: ["state"],
      group: "状态",
    },
    {
      name: "placement",
      label: "位置",
      type: PropType.ENUM,
      defaultValue: "right",
      options: [
        { label: "上", value: "top" },
        { label: "右", value: "right" },
        { label: "下", value: "bottom" },
        { label: "左", value: "left" },
      ],
      group: "布局",
    },
    {
      name: "width",
      label: "宽度",
      type: PropType.NUMBER,
      defaultValue: 520,
      description: "左右位置时的宽度",
      group: "布局",
    },
    {
      name: "height",
      label: "高度",
      type: PropType.NUMBER,
      defaultValue: 378,
      description: "上下位置时的高度",
      group: "布局",
    },
    {
      name: "closable",
      label: "显示关闭按钮",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "基础",
    },
    {
      name: "mask",
      label: "显示遮罩",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
    {
      name: "maskClosable",
      label: "点击遮罩关闭",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "destroyOnClose",
      label: "关闭时销毁",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
  ],
  defaultProps: {
    title: "抽屉标题",
    open: true,
    placement: "right",
    width: 378,
  },
  defaultStyle: {
    width: 378,
  },
  npm: {
    package: "antd",
    exportName: "Drawer",
  },
  snippet: {
    componentName: "Drawer",
    package: "antd",
    props: { title: "抽屉标题", open: true, placement: "right" },
    children: [],
  },
};
